<template>
  <v-container fluid>
    <v-parallax 
    :src="require('@/assets/compass.jpg')"
    aspect-ratio="1.7"
    height="300"
    class="my-2">
      <v-layout align-center justify-space-around row wrap fill-height>
        <h1 class="display-3 font-weight-thin white--text ma-2">Our Services</h1>
      </v-layout>
    </v-parallax>
    <v-layout row wrap>
      <v-flex class="my-4">
        <v-layout row wrap 
        text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-2 font-weight-thin my-2">M&amp;A and Capital Raising</h1>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 md6>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-parallax
                  :src="require('@/assets/handshakecolor.jpg')"
                  >
                    <v-container fill-height>
                      <v-layout align-center>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <div class="shadow">
                              <h1 class="display-2 font-weight-thin white--text ">Mergers &amp; Acquisitions</h1>
                              <h2 class="display-5 font-weight-thin white--text">Total or partial acquisition, merger, or sale of companies.</h2>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-parallax>

                  <v-card-title primary-title>
                    <div>
                      <div class="headline ml-2">Differentiated strategic and tactical advice as well as efficient execution:
                        <v-spacer></v-spacer>
                        <v-btn flat  @click="showMAD = !showMAD">
                          <div>{{ showMAD ? 'Read Less' : 'Read More' }}</div>
                        </v-btn>
                        <v-btn icon @click="showMAD = !showMAD">
                          <v-icon>{{ showMAD ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                      </div>
                      <v-slide-y-transition>
                        <v-list three-line
                        v-show="showMAD">
                          <template v-for="(maDetail, i) in maDetails">

                            <v-list-tile
                              :key="i"
                              avatar
                              class="my-2"
                            >
                              <v-list-tile-avatar>
                                <v-icon color="accent">{{maDetail.icon}}</v-icon>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title>{{maDetail.title}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{maDetail.subtitle}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                        </v-list>
                      </v-slide-y-transition>
                    </div>
                  </v-card-title>
                  
                  <v-card-actions>
                    <v-layout 
                    align-center 
                    justify-center 
                    row wrap 
                    fill-height
                    class="mb-2">
                      <v-btn 
                      color="accent"
                      class="white--text"
                      :to="'/contact'">Contact Us</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex sm12 md6>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-parallax
                  :src="require('@/assets/singaporecolor.jpg')"
                  >
                    <v-container fill-height>
                      <v-layout align-center>
                        <v-layout row wrap>
                          <v-flex xs12 class="shadow">
                            <h1 class="display-2 font-weight-thin white--text">Capital Raising</h1>
                            <h2 class="display-5 font-weight-thin white--text">Direct private equity, credit, or hybrid financing solutions: </h2>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-parallax>

                  <v-card-title primary-title>
                    <div>
                      <div class="headline ml-2">We leverage our extensive experience executing complex transactions to help address your objectives, including:
                        <v-spacer></v-spacer>
                        <v-btn flat  @click="showCRD = !showCRD">
                          <div>{{ showCRD ? 'Read Less' : 'Read More' }}</div>
                        </v-btn>
                        <v-btn icon @click="showCRD = !showCRD">
                          <v-icon>{{ showCRD ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                      </div>
                      <v-slide-y-transition>
                        <v-list three-line
                        v-show="showCRD">
                          <template v-for="(crDetail, i) in crDetails">

                            <v-list-tile
                              :key="i"
                              avatar
                              class="my-2"
                            >
                              <v-list-tile-avatar>
                                <v-icon color="accent">{{crDetail.icon}}</v-icon>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title>{{crDetail.title}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{crDetail.subtitle}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                        </v-list>
                      </v-slide-y-transition>
                    </div>
                  </v-card-title>
                  
                  <v-card-actions>
                    <v-layout 
                    align-center 
                    justify-center 
                    row wrap 
                    fill-height
                    class="mb-2">
                      <v-btn 
                      color="accent"
                      class="white--text"
                      :to="'/contact'">Contact Us</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        showMAD: true,
        showCRD: true,
        maDetails: [
          {
            icon: 'assignment_turned_in',
            title: 'Deal Evaluation',
            subtitle: 'We evaluate potential targets, provide valuation analyses, and evaluate and propose financial and strategic alternatives.'
          },
          {
            icon: 'question_answer',
            title: 'Independent Advice',
            subtitle: 'We provide boards and management teams with independent judgment and deep sector and geographic expertise.'
          },
          {
            icon: 'gavel',
            title: 'Deal Execution',
            subtitle: 'We also advise as to the timing, structure, financing, and pricing of a proposed transaction as well as assist in negotiating and closing the deal.'
          }
        ],
        crDetails: [
          {
            icon: 'work',
            title: 'Private Equity Sales',
            subtitle: 'Traditional and pre-IPO equity placements for private companies, and shareholder replacements.'
          },
          {
            icon: 'trending_up',
            title: 'Growth Capital',
            subtitle: 'Acquisition-related private equity or debt financing, project financing.'
          },
          {
            icon: 'autorenew',
            title: 'Recapitalization',
            subtitle: 'Equity recapitalizations / debt refinancings, sovereign debt refinancing, Private Investments in Public Entities (“PIPEs”) for public companies.'
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .shadow {
    position: absolute;
    top: 30%;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    color: white;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/services.vue